<template>
    <div>
        <main-layout-content :breadcrumbs="pageBreadcrumbs">
            <template #content>
                <common-tabs v-if="tabs.length" ref="tabs" :tabs="tabs" :activeTab="tabs[0].name" @tab-change="tabChanged">
                    <template #profile>
                        <company-details
                            v-if="company && companyAvgRating && companyRatings && companyUsers"
                            :company="company"
                            :companyAvgRating="companyAvgRating"
                            :companyRatings="companyRatings"
                            :companyUsers="companyUsers"
                            @go-to-offer-tab="$refs.tabs.tabClicked('offers')"
                        ></company-details>
                    </template>
                    <template #offers>
                        <company-offer v-if="companyOffers" :companyOffers="companyOffers"></company-offer>
                    </template>
                </common-tabs>
            </template>
        </main-layout-content>
    </div>
</template>

<script>
    import RoutesEnum from 'enums/routes.enum'
    import MainLayoutContent from 'components/layouts/layout-content/MainLayoutContent'
    import CompanyDetails from 'components/page-elements/company/CompanyDetails'
    import CompanyOffer from 'components/page-elements/company/CompanyOffer'
    import CompanyAPI from 'api/CompanyAPI'
    import RatingAPI from 'api/RatingAPI'
    import OfferAPI from 'api/OfferAPI'
    import { setSiteTitle, setMetaTitle, setMetaDescription } from '~/helpers'

    export default {
        components: { MainLayoutContent, CompanyDetails, CompanyOffer },

        data() {
            return {
                company: null,
                companyAvgRating: null,
                companyRatings: null,
                companyOffers: null,
                companyUsers: [],
            }
        },

        computed: {
            tabs() {
                return [
                    {
                        name: 'profile',
                        displayName: this.$t('pages.company.my_company.tabs.profile'),
                        icon: 'profile',
                        withPadding: true,
                    },
                    {
                        name: 'offers',
                        displayName: this.$t('pages.user.user_profile.tabs.offers'),
                        icon: 'calendar',
                        withPadding: true,
                    },
                ]
            },
            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.user.user_profile.breadcrumbs.home'),
                        route: { name: RoutesEnum.INDEX.HOME },
                    },
                    {
                        label: this.$t('pages.company.my_company.breadcrumbs.preview'),
                    },
                ]
            },
        },

        methods: {
            tabChanged(tab) {
                this.$router.push({ name: RoutesEnum.COMPANY.PROFILE, params: { id: this.$route.params.id, companyType: tab } })
            },

            fetchCompanyData() {
                CompanyAPI.getPublicById(this.$route.params.id)
                    .then((val) => {
                        this.company = val
                        this.companyAvgRating = [
                            {
                                id: val.id,
                                numberOfRatings: val.numberOfRatings,
                                averageRating: val.averageRating,
                            },
                        ]

                        setSiteTitle(`${this.company.name} | Bookeraj`)
                        setMetaTitle(`${this.company.name} | Bookeraj`)
                        if (this.company?.descriptionTextContent?.originalText) {
                            setMetaDescription(`${this.company?.descriptionTextContent?.originalText}`)
                        }
                    })
                    .catch((err) => {
                        if (err.error.message === 'COMPANY.NOT_FOUND') {
                            this.$router.push({ name: RoutesEnum.ERROR.NO_ACCESS })
                        }
                    })

                RatingAPI.getRatingsForCompany({ companyId: this.$route.params.id, take: 25, skip: 0 }).then(
                    (res) => (this.companyRatings = res),
                )
                OfferAPI.getPublicCompanyOffersById(this.$route.params.id).then((val) => {
                    this.companyOffers = val
                })
                CompanyAPI.getCompanyTeam(this.$route.params.id).then((val) => {
                    this.companyUsers = val
                })
            },
        },

        watch: {
            '$route.params.companyType': {
                handler: function () {
                    if (this.$route.params.id && this.$route.params.companyType) {
                        this.$refs.tabs.tabClicked(this.$route.params.companyType)
                    }
                },
            },
        },

        mounted() {
            this.fetchCompanyData()
            this.$nextTick(() => {
                if (this.$route.params.id && this.$route.params.companyType) {
                    this.$refs.tabs.tabClicked(this.$route.params.companyType)
                }
            })
        },
    }
</script>
